module.exports = __webpack_public_path__ + "static/media/theme-icons.af0fea31.svg";